import ActivityTimelineView from 'src/features/leads/view/ActivityTimelineView';
import NotesView from 'src/features/leads/view/NotesView';
import AccountDetailsView from 'src/features/leads/view/AccountDetailsView';
import { LeadScreenStore, ViewType } from 'src/stores/LeadStore';
import ActivityExecutionView from 'src/features/leads/view/ActivityExecutionView';
import CadenceDetailsView from './CadenceDetailsView';
import SprintDetailsView from './SprintDetailsView';
import CompanyDetailsView from './CompanyDetailsView';
import TaskView from './TaskView';
import SimpleDialog from '../../common/SimpleDialog';
import { useMemo } from 'react';

const LeadViewRight = () => {
    const selectedView = LeadScreenStore.useState((s) => s.selectedView);

    const open = useMemo(() => {
        return (
            selectedView === ViewType.ActivityTimeline ||
            selectedView === ViewType.Notes ||
            selectedView === ViewType.AccountDetails ||
            selectedView === ViewType.ActivityExecution ||
            selectedView === ViewType.ViewCadence ||
            selectedView === ViewType.ViewSprint ||
            selectedView === ViewType.ViewCompany ||
            selectedView === ViewType.Tasks
        );
    }, [selectedView]);

    const onClose = () => {
        LeadScreenStore.update((s) => {
            s.selectedView = ViewType.None;
        });
    };

    return (
        <SimpleDialog open={open} onClose={onClose} fullHeight={false} padding={0}>
            {selectedView === ViewType.ActivityTimeline && <ActivityTimelineView onClose={onClose} />}
            {selectedView === ViewType.Notes && <NotesView onClose={onClose} />}
            {selectedView === ViewType.AccountDetails && <AccountDetailsView onClose={onClose} />}
            {selectedView === ViewType.ActivityExecution && <ActivityExecutionView />}
            {selectedView === ViewType.ViewCadence && <CadenceDetailsView onClose={onClose} />}
            {selectedView === ViewType.ViewSprint && <SprintDetailsView onClose={onClose} />}
            {selectedView === ViewType.ViewCompany && <CompanyDetailsView onClose={onClose} />}
            {selectedView === ViewType.Tasks && <TaskView onClose={onClose} />}
        </SimpleDialog>
    );
};

export { LeadViewRight };

export default LeadViewRight;
